module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg9lev1"
    }
  }, [_vm._v("introduction")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06introduction#pg9lev1"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07chapter01#pg13lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("getting started")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/07chapter01#pg13lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg14lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg14lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gloves")]), _vm._v(" "), _c('span', {
    staticClass: "font"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg14lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand Tools")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg16lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg18lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pruning Tools")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg18lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watering Containers")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#pg20lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg22lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fertilizer")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg22lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pots and Containers")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg26lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("quick guide to repotting")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg26lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potting Mixes")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the happy houseplants")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("African Violet")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Plant")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aloe Vera")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amaryllis")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#pg40lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Chalk Sticks")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#pg40lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burro’s Tail Cactus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#pg42lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter11#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chili Pepper Plant")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter11#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter12#pg46lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cushion Moss")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter12#pg46lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter13#pg48lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desert Rose")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter13#pg48lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter14#pg50lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairy Castle Cactus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter14#pg50lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter15#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("False Shamrock")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter15#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter16#pg54lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firestick Cactus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter16#pg54lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter17#pg56lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foxtail Fern")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter17#pg56lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter18#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grape Hyacinth")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter18#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter19#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hen and Chicks")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter19#pg60lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter20#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jade Plant")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26chapter20#pg62lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter21#pg64lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jasmine")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27chapter21#pg64lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter22#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Button Fern")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28chapter22#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter23#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lily of the Valley")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29chapter23#pg68lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter24#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Bamboo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/30chapter24#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter25#pg72lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maidenhair Fern")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31chapter25#pg72lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32chapter26#pg74lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moon Cactus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/32chapter26#pg74lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33chapter27#pg76lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paperwhites")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/33chapter27#pg76lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34chapter28#pg78lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ponytail Palm")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/34chapter28#pg78lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35chapter29#pg80lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prickly Pear")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/35chapter29#pg80lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36chapter30#pg82lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Vase Plant")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/36chapter30#pg82lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37chapter31#pg84lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snake Plant")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/37chapter31#pg84lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38chapter32#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("String of Pearls")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/38chapter32#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter33#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tulip")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/39chapter33#pg88lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40chapter34#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zebra Cactus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/40chapter34#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg93lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resources")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg93lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg94lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg94lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg94lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materials")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg94lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg95lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plants")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41resources#pg95lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42acknowledgments#pg96lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgments")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/42acknowledgments#pg96lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("96")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0